import request from "@/config/axios";

const mode = 'basedata'; // 对应config里的oDomains的key
// 通过用户id查询用户身份信息
export function queryIdentityByUserId(params) {
  return request({
    url: '/v1/identity/queryIdentityByUserId',
    method: 'GET', 
    mode,
    params,
  })
}

// 根据教师id查询带班信息
export function getTeachingInfo(params) {
  return request({
    url: '/v1/teacher/getTeachingInfo',
    method: 'GET', 
    mode,
    params,
  })
}
// 根据班级id获取学生下拉列表
export function getStudentListByClassId(params) {
  return request({
    url: '/v1/student/getStudentListByClassId',
    method: 'GET', 
    mode,
    params,
  })
}
// 根据学生id获取家长信息
export function getParentInfoByStudentId(params) {
  return request({
    url: '/v1/parent/getParentInfoByStudentId',
    method: 'GET', 
    mode,
    params,
  })
}

// 移除学生
export function delStudentFromClass(data) {
  return request({
    url: '/v1/teacher/removeClass',
    method: 'POST', 
    mode,
    data,
  })
}


// 设置家长绑定信息
export function updateParentKinship(data) {
  return request({
    url: '/v1/parent/updateParentKinship',
    method: 'post',
    mode,
    data
  })
}
// 删除家长绑定信息
export function deleteParentKinship(data) {
  return request({
    url: '/v1/parent/deleteParentKinship',
    method: 'post',
    mode,
    params:data
  })
}

// 修改密码
export function modifyPassword(data) {
  return request({
    url: "/v1/user/modifyPassword",
    method: "POST",
    mode,
    data
  });
}

// 切换用户当前身份类型
export function switchUserType(data) {
  return request({
    url: "/v1/user/switchUserType",
    method: "POST",
    mode,
    data
  });
}
// 切换用户到指定身份
export function switchUserIdentity(data) {
  return request({
    url: "/v1/user/switchUserIdentity",
    method: "POST",
    mode,
    data
  });
}


// 电子学生证绑定
export function binding(data) {
  return request({
    url: "/v1/student/binding",
    method: "POST",
    mode,
    data
  });
}
// 电子学生证解绑
export function unbinding(data) {
  return request({
    url: "/v1/student/unbinding",
    method: "POST",
    mode,
    data
  });
}
// 修改学生手机号
export function updateContactPhone(data) {
  return request({
    url: "/v1/student/updateContactPhone",
    method: "POST",
    mode,
    data
  });
}
// 获取设备基本信息
export function queryByImei(params) {
  return request({
    url: "/api/device/v1/device/queryByImei",
    method: "GET",
    mode:'base',
    params,
  });
}
// 设备激活
export function activate(params) {
  return request({
    url: "/v1/student/activate",
    method: "POST",
    mode,
    params,
  });
}

// 获取帮助中心分类
export function getHelpType() {
  return request({
    url: "/v1/help/share/getHelpType",
    method: "GET",
    mode
  });
}
// 分页获取帮助列表
export function getHelpList(params) {
  return request({
    url: "/v1/help/share/getHelpList",
    method: "GET",
    mode,
    params
  });
}
// 获取帮助详情
export function getHelpInfo(params) {
  return request({
    url: '/v1/help/share/getHelpInfo',
    method: 'GET', 
    mode,
    params,
  })
}
// 根据学生id查询升级信息
export function queryByStudentId(params) {
  return request({
    url: '/v1/ota/queryByStudentId',
    method: 'GET', 
    mode,
    params,
  })
}
// 升级版本
export function upgrade(data) {
  return request({
    url: "/v1/ota/upgrade",
    method: "POST",
    mode,
    data
  });
}
// 获取学生基本信息
export function getStudentInfo(params) {
  return request({
    url: "/v1/student/getStudentInfo",
    method: "GET",
    mode,
    params
  });
}
// 获取安全码
export function getEduCode(params) {
  return request({
    url: "/v1/student/getEduCode",
    method: "GET",
    mode,
    params
  });
}
// 可信身份解绑
export function trustedIdentityUnbinding(params) {
  return request({
    url: "/v1/student/trustedIdentityUnbinding",
    method: "POST",
    mode,
    params
  });
}
// 删除学生
export function deleteStudent(params) {
  return request({
    url: "/v1/student/deleteStudent",
    method: "POST",
    mode,
    params,
  });
}
// 检查IMEI是否可用来注册的接口
export function verifyAvailabilityByImei(params) {
  return request({
    url: "/v1/register/verifyAvailabilityByImei",
    method: "GET",
    mode,
    params
  });
}
// 20.2.绑定子女信息的接口
export function bindingChild(data) {
  return request({
    url: "/v1/register/bindingChild",
    method: "POST",
    mode,
    data
  });
}
// 根据班级id获取学生下拉列表
export function getTeacherListByClassId(params) {
  return request({
    url: '/v1/teacher/getTeacherByClassId',
    method: 'GET', 
    mode,
    params,
  })
}
// 20.8.生成邀请码
export function madeInviteCode(params) {
  return request({
    url: "/v1/register/inviteJoinClass",
    method: "GET",
    mode,
    params
  });
}
// 20.9.家长根据邀请码获取信息
export function getInfoByInviteCode(params) {
  return request({
    url: "/v1/register/getInfoByInviteCode",
    method: "GET",
    mode,
    params
  });
}
// 20.10.获取子女信息
export function getStudentByParent(params) {
  return request({
    url: "/v1/parent/getStudentByParent",
    method: "GET",
    mode,
    params
  });
}
// 20.2.绑定子女信息的接口
export function joinClass(data) {
  return request({
    url: "/v1/student/joinClass",
    method: "POST",
    mode,
    data
  });
}
// 20.2.绑定子女信息的接口
export function getStudentsList(params) {
  return request({
    url: "/v1/student/multiGetStudentBaseInfo",
    method: "GET",
    mode,
    params
  });
}
// 编辑保存子女
export function updateChild(data) {
  return request({
    url: "/v1/student/updateChild",
    method: "POST",
    mode,
    data
  });
}

// 意见反馈
export function feedbackAdd(data) {
  return request({
    url: "/v1/opinion/add",
    method: "POST",
    mode,
    data
  });
}
